import { all, takeLatest, fork } from 'redux-saga/effects';

import { loginStatusWatcher, signIn, signOut, forgotPassword } from './auth';
import { AuthTypes } from '../ducks/auth';

import {
  getTruckers,
  getOneTrucker,
  getCpfTrucker,
  addTrucker,
  updateTrucker,
  removeTrucker,
  reportPending,
  updateAditionalDocument,
  setDocumentData,
} from './trucker';
import { TruckerTypes } from '../ducks/trucker';

import {
  getCollabs,
  addCollab,
  updateCollab,
  reactivateCollab,
  removeCollab,
} from './collaborators';
import { CollabsTypes } from '../ducks/collaborators';

import { getCtes, confirmPayment, cancelPayment, getViagens, addViagem, updateViagem, removeViagem } from './trip';
import { TripTypes } from '../ducks/trip';

import { getNotifications, addNotification, getUsers } from './notification';
import { NotificationsTypes } from '../ducks/notifications';

import { getUndoneUser, getDashboard, getYearsOptions } from './dashboard';
import { DashboardTypes } from '../ducks/dashboard';

import {
  getConvocations,
  addConvocation,
  updateConvocation,
  removeConvocation,
  sendMail,
  updateLocation,
  getTemporaryLink,
  convocationsWatcher,
} from './convocations';
import { ConvocationsTypes } from '../ducks/convocations';

import { getInsurances, addInsurance, updateInsurance, removeInsurance } from './insurances';
import { InsurancesTypes } from '../ducks/insurances';

import {
  getProfiles,
  getProfile,
  addProfile,
  updateProfile,
  removeProfile,
  getMyPermissions,
} from './profiles';
import { ProfilesTypes } from '../ducks/profiles';

import { getCte, addCte, updateCte, removeCte, getIdCte } from './cte';
import { CteTypes } from '../ducks/cte';

import {
  getProviders,
  addProvider,
  updateProvider,
  removeProvider,
} from './providers';
import { ProvidersTypes } from '../ducks/providers';

import {
  getReports,
  removeReport,
  setReportOld,
  setReportOldAll,
} from './reports';
import { ReportsTypes } from '../ducks/reports';

import { getChat, getMessages, addMessage } from './chat';
import { ChatTypes } from '../ducks/chat';
import { IssuersTypes } from '../ducks/issuers';
import { addIssuers, getIssuers, updateIssuer } from './issuer';

import { AntecipationsTypes } from '../ducks/antecipations';
import {
  deleteFileAntecipations,
  fileAntecipations,
  getAntecipations,
  getIdAntecipations,
  removeAntecipations,
  updateAntecipations,
} from './antecipations';

import { AccountsPayableTypes } from '../ducks/accountsPayable';
import {
  getAccountsPayable,
  addAccountPayable,
  updateAccountPayable,
  removeAccountPayable,
} from './accountsPayable';

import { AccountsReceivableTypes } from '../ducks/accountsReceivable';
import {
  getAccountsReceivable,
  addAccountReceivable,
  updateAccountReceivable,
  removeAccountReceivable,
} from './accountsReceivable';

import { ClientesTypes } from '../ducks/clientes';
import {
  getClientes,
  addCliente,
  updateCliente,
  removeCliente,
} from './clientes';

import { NaturezasTypes } from '../ducks/naturezas';
import {
  getNaturezas,
  addNatureza,
  updateNatureza,
  removeNatureza,
} from './naturezas';

import { FornecedoresTypes } from '../ducks/fornecedores';
import {
  getFornecedores,
  addFornecedor,
  updateFornecedor,
  removeFornecedor,
} from './fornecedores';

import { EmbarcadoresTypes } from '../ducks/embarcadores';
import {
  getEmbarcadores,
  addEmbarcador,
  updateEmbarcador,
  removeEmbarcador,
} from './embarcadores';

export default function* rootSaga() {
  yield fork(loginStatusWatcher);
  // convocationsWatcher desabilitado - usando APIs REST agora
  // yield fork(convocationsWatcher);
  yield all([
    takeLatest(AuthTypes.SIGN_IN_REQUEST, signIn),
    takeLatest(AuthTypes.SIGN_OUT, signOut),
    takeLatest(AuthTypes.FORGOT_REQUEST, forgotPassword),

    takeLatest(TruckerTypes.GET_TRUCKERS_REQUEST, getTruckers),
    takeLatest(TruckerTypes.GET_ONE_TRUCKER_REQUEST, getOneTrucker),
    takeLatest(TruckerTypes.GET_CPF_TRUCKER_REQUEST, getCpfTrucker),
    takeLatest(TruckerTypes.ADD_TRUCKER_REQUEST, addTrucker),
    takeLatest(TruckerTypes.UPDATE_TRUCKER_REQUEST, updateTrucker),
    takeLatest(TruckerTypes.REMOVE_TRUCKER_REQUEST, removeTrucker),
    takeLatest(TruckerTypes.REPORT_PENDING_REQUEST, reportPending),
    takeLatest(
      TruckerTypes.UPDATE_ADITIONAL_DOCUMENT_REQUEST,
      updateAditionalDocument
    ),
    takeLatest(TruckerTypes.SET_DOCUMENT_DATA_REQUEST, setDocumentData),

    takeLatest(CollabsTypes.GET_COLLABS_REQUEST, getCollabs),
    takeLatest(CollabsTypes.ADD_COLLAB_REQUEST, addCollab),
    takeLatest(CollabsTypes.UPDATE_COLLAB_REQUEST, updateCollab),
    takeLatest(CollabsTypes.REACTIVATE_COLLAB_REQUEST, reactivateCollab),
    takeLatest(CollabsTypes.REMOVE_COLLAB_REQUEST, removeCollab),

    takeLatest(TripTypes.GET_CTES_REQUEST, getCtes),
    takeLatest(TripTypes.CONFIRM_PAYMENT_REQUEST, confirmPayment),
    takeLatest(TripTypes.CANCEL_PAYMENT_REQUEST, cancelPayment),
    takeLatest(TripTypes.GET_VIAGENS_REQUEST, getViagens),
    takeLatest(TripTypes.ADD_VIAGEM_REQUEST, addViagem),
    takeLatest(TripTypes.UPDATE_VIAGEM_REQUEST, updateViagem),
    takeLatest(TripTypes.REMOVE_VIAGEM_REQUEST, removeViagem),

    takeLatest(NotificationsTypes.GET_NOTIFICATIONS_REQUEST, getNotifications),
    takeLatest(NotificationsTypes.ADD_NOTIFICATION_REQUEST, addNotification),
    takeLatest(NotificationsTypes.GET_USERS_REQUEST, getUsers),

    takeLatest(DashboardTypes.GET_UNDONE_USER_REQUEST, getUndoneUser),
    takeLatest(DashboardTypes.GET_DASHBOARD_REQUEST, getDashboard),
    takeLatest(DashboardTypes.GET_YEARS_OPTIONS_REQUEST, getYearsOptions),

    takeLatest(ConvocationsTypes.GET_CONVOCATIONS_REQUEST, getConvocations),
    takeLatest(ConvocationsTypes.ADD_CONVOCATION_REQUEST, addConvocation),
    takeLatest(ConvocationsTypes.UPDATE_LOCATION_REQUEST, updateLocation),
    takeLatest(ConvocationsTypes.UPDATE_CONVOCATION_REQUEST, updateConvocation),
    takeLatest(ConvocationsTypes.REMOVE_CONVOCATION_REQUEST, removeConvocation),
    takeLatest(ConvocationsTypes.PUT_SEND_MAIL_REQUEST, sendMail),
    takeLatest(ConvocationsTypes.OPEN_SHARE_MODAL, getTemporaryLink),

    takeLatest(CteTypes.GET_CTE_REQUEST, getCte),
    takeLatest(CteTypes.ADD_CTE_REQUEST, addCte),
    takeLatest(CteTypes.UPDATE_CTE_REQUEST, updateCte),
    takeLatest(CteTypes.REMOVE_CTE_REQUEST, removeCte),
    takeLatest(CteTypes.GET_ID_CTE_REQUEST, getIdCte),

    takeLatest(ProvidersTypes.GET_PROVIDERS_REQUEST, getProviders),
    takeLatest(ProvidersTypes.ADD_PROVIDER_REQUEST, addProvider),
    takeLatest(ProvidersTypes.UPDATE_PROVIDER_REQUEST, updateProvider),
    takeLatest(ProvidersTypes.REMOVE_PROVIDER_REQUEST, removeProvider),

    takeLatest(ProfilesTypes.GET_PROFILES_REQUEST, getProfiles),
    takeLatest(ProfilesTypes.GET_PROFILE_REQUEST, getProfile),
    takeLatest(ProfilesTypes.ADD_PROFILE_REQUEST, addProfile),
    takeLatest(ProfilesTypes.UPDATE_PROFILE_REQUEST, updateProfile),
    takeLatest(ProfilesTypes.REMOVE_PROFILE_REQUEST, removeProfile),
    takeLatest(ProfilesTypes.GET_MY_PERMISSIONS_REQUEST, getMyPermissions),

    takeLatest(ReportsTypes.GET_REPORTS_REQUEST, getReports),
    takeLatest(ReportsTypes.REMOVE_REPORT_REQUEST, removeReport),
    takeLatest(ReportsTypes.SET_REPORT_OLD_REQUEST, setReportOld),
    takeLatest(ReportsTypes.SET_REPORT_OLD_ALL_REQUEST, setReportOldAll),

    takeLatest(ChatTypes.GET_CHAT_REQUEST, getChat),
    takeLatest(ChatTypes.GET_MESSAGES_REQUEST, getMessages),
    takeLatest(ChatTypes.ADD_MESSAGE_REQUEST, addMessage),

    takeLatest(IssuersTypes.GET_ISSUERS_REQUEST, getIssuers),
    takeLatest(IssuersTypes.ADD_ISSUER_REQUEST, addIssuers),
    takeLatest(IssuersTypes.UPDATE_ISSUER_REQUEST, updateIssuer),

    takeLatest(AntecipationsTypes.GET_ANTECIPATIONS_REQUEST, getAntecipations),
    takeLatest(
      AntecipationsTypes.UPDATE_ANTECIPATIONS_REQUEST,
      updateAntecipations
    ),
    takeLatest(
      AntecipationsTypes.REMOVE_ANTECIPATIONS_REQUEST,
      removeAntecipations
    ),
    takeLatest(
      AntecipationsTypes.FILE_ANTECIPATIONS_REQUEST,
      fileAntecipations
    ),
    takeLatest(
      AntecipationsTypes.DELETE_FILE_ANTECIPATIONS_REQUEST,
      deleteFileAntecipations
    ),
    takeLatest(
      AntecipationsTypes.GET_ID_ANTECIPATIONS_REQUEST,
      getIdAntecipations
    ),

    takeLatest(InsurancesTypes.GET_INSURANCES_REQUEST, getInsurances),
    takeLatest(InsurancesTypes.ADD_INSURANCE_REQUEST, addInsurance),
    takeLatest(InsurancesTypes.UPDATE_INSURANCE_REQUEST, updateInsurance),
    takeLatest(InsurancesTypes.REMOVE_INSURANCE_REQUEST, removeInsurance),

    takeLatest(AccountsPayableTypes.GET_ACCOUNTS_PAYABLE_REQUEST, getAccountsPayable),
    takeLatest(AccountsPayableTypes.ADD_ACCOUNT_PAYABLE_REQUEST, addAccountPayable),
    takeLatest(AccountsPayableTypes.UPDATE_ACCOUNT_PAYABLE_REQUEST, updateAccountPayable),
    takeLatest(AccountsPayableTypes.REMOVE_ACCOUNT_PAYABLE_REQUEST, removeAccountPayable),

    takeLatest(AccountsReceivableTypes.GET_ACCOUNTS_RECEIVABLE_REQUEST, getAccountsReceivable),
    takeLatest(AccountsReceivableTypes.ADD_ACCOUNT_RECEIVABLE_REQUEST, addAccountReceivable),
    takeLatest(AccountsReceivableTypes.UPDATE_ACCOUNT_RECEIVABLE_REQUEST, updateAccountReceivable),
    takeLatest(AccountsReceivableTypes.REMOVE_ACCOUNT_RECEIVABLE_REQUEST, removeAccountReceivable),

    takeLatest(ClientesTypes.GET_CLIENTES_REQUEST, getClientes),
    takeLatest(ClientesTypes.ADD_CLIENTE_REQUEST, addCliente),
    takeLatest(ClientesTypes.UPDATE_CLIENTE_REQUEST, updateCliente),
    takeLatest(ClientesTypes.REMOVE_CLIENTE_REQUEST, removeCliente),

    takeLatest(NaturezasTypes.GET_NATUREZAS_REQUEST, getNaturezas),
    takeLatest(NaturezasTypes.ADD_NATUREZA_REQUEST, addNatureza),
    takeLatest(NaturezasTypes.UPDATE_NATUREZA_REQUEST, updateNatureza),
    takeLatest(NaturezasTypes.REMOVE_NATUREZA_REQUEST, removeNatureza),

    takeLatest(FornecedoresTypes.GET_FORNECEDORES_REQUEST, getFornecedores),
    takeLatest(FornecedoresTypes.ADD_FORNECEDOR_REQUEST, addFornecedor),
    takeLatest(FornecedoresTypes.UPDATE_FORNECEDOR_REQUEST, updateFornecedor),
    takeLatest(FornecedoresTypes.REMOVE_FORNECEDOR_REQUEST, removeFornecedor),

    takeLatest(EmbarcadoresTypes.GET_EMBARCADORES_REQUEST, getEmbarcadores),
    takeLatest(EmbarcadoresTypes.ADD_EMBARCADOR_REQUEST, addEmbarcador),
    takeLatest(EmbarcadoresTypes.UPDATE_EMBARCADOR_REQUEST, updateEmbarcador),
    takeLatest(EmbarcadoresTypes.REMOVE_EMBARCADOR_REQUEST, removeEmbarcador),
  ]);
}
